import { toast } from "react-toastify"
import { apiConstants } from "../apiConstant"
import compileErrors from "../compileErorrs"
import { serviceCall, serviceCallGenerate } from "../serviceCall"
import { setLoading } from "../../feature/authSlice"

export const updatePaymentAdviceApi = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    dispatch(setLoading(true))
    serviceCallGenerate({
      url: apiConstants.Invoices.UPDATE_PAYMENT_ADVICE,
      method: 'post',
      data: data,
    })
      .then((response) => {
        dispatch(setLoading(false))
        callback && callback(response)
      })
      .catch((error) => {
        dispatch(setLoading(false))
        toast.error(compileErrors(error?.response?.data?.error))
        errorCallBack && errorCallBack(error.response)
      })
  }
}
